import styles from './previewlimit.css'

type PreviewLimitProps = {
  previewBeginRatio: number
}

const PreviewLimit = ({ previewBeginRatio }: PreviewLimitProps): JSX.Element => {
  return <div className={styles.previewLimit} style={{ width: `${(100 - previewBeginRatio * 100).toFixed(1)}%` }} />
}

export default PreviewLimit
